import React from 'react';

export const MSLogo = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 110 71" fill="currentColor" aria-hidden="true" {...props}>
        <path d="M17.0322 35.7189L34.0616 71.0013H0L17.0322 35.7189Z" />
        <path d="M13.9918 0L47.6227 71.0013H72.0364L37.423 0H13.9918Z" />
        <path d="M51.9525 0L85.5834 71.0013H110L75.3838 0H51.9525Z" />
    </svg>
);
